export { default as animatedReviews_16 } from './animated-reviews_16.svg';
export { default as arrowDownUp_16 } from './arrow-down-up_16.svg';
export { default as arrowDown_16 } from './arrow-down_16.svg';
export { default as arrowInCircle_16 } from './arrow-in-circle_16.svg';
export { default as arrowRight_16 } from './arrow-right_16.svg';
export { default as arrowStemRight_16 } from './arrow-stem-right_16.svg';
export { default as arrowUp_16 } from './arrow-up_16.svg';
export { default as arrow_16 } from './arrow_16.svg';
export { default as atSign_16 } from './at-sign_16.svg';
export { default as burgerMenu_16 } from './burger-menu_16.svg';
export { default as calendarArrow_16 } from './calendar-arrow_16.svg';
export { default as calendarRangeArrow_16 } from './calendar-range-arrow_16.svg';
export { default as calendar2_16 } from './calendar2_16.svg';
export { default as calendar_16 } from './calendar_16.svg';
export { default as cart_16 } from './cart_16.svg';
export { default as chat_16 } from './chat_16.svg';
export { default as check_16 } from './check_16.svg';
export { default as checkmark_16 } from './checkmark_16.svg';
export { default as claimed_16 } from './claimed_16.svg';
export { default as close_16 } from './close_16.svg';
export { default as companyTrustscore_16 } from './company-trustscore_16.svg';
export { default as contrastDark_24 } from './contrast-dark_24.svg';
export { default as contrastLight_24 } from './contrast-light_24.svg';
export { default as copy_16 } from './copy_16.svg';
export { default as cross_16 } from './cross_16.svg';
export { default as downloadImage_16 } from './download-image_16.svg';
export { default as downloadImage_24 } from './download-image_24.svg';
export { default as dropdown_16 } from './dropdown_16.svg';
export { default as export_16 } from './export_16.svg';
export { default as externalLink_16 } from './external-link_16.svg';
export { default as facebook_16 } from './facebook_16.svg';
export { default as findReviewer_16 } from './find-reviewer_16.svg';
export { default as flagOutline_16 } from './flag-outline_16.svg';
export { default as gift_16 } from './gift_16.svg';
export { default as globe_16 } from './globe_16.svg';
export { default as google_16 } from './google_16.svg';
export { default as info2_16 } from './info2_16.svg';
export { default as info2_outline_16 } from './info2_outline_16.svg';
export { default as info_16 } from './info_16.svg';
export { default as instagram_16 } from './instagram_16.svg';
export { default as letter_16 } from './letter_16.svg';
export { default as linkedin_16 } from './linkedin_16.svg';
export { default as lock_16 } from './lock_16.svg';
export { default as mapPin_16 } from './map-pin_16.svg';
export { default as mergedProfile_16 } from './merged-profile_16.svg';
export { default as misclassified_16 } from './misclassified_16.svg';
export { default as pastReviews_16 } from './past-reviews_16.svg';
export { default as pending_16 } from './pending_16.svg';
export { default as phone_16 } from './phone_16.svg';
export { default as plane2_16 } from './plane2_16.svg';
export { default as plane_16 } from './plane_16.svg';
export { default as plusCircle_16 } from './plus-circle_16.svg';
export { default as positioningBottomLeft_24 } from './positioning-bottom-left_24.svg';
export { default as positioningBottomRight_24 } from './positioning-bottom-right_24.svg';
export { default as positioningBottom_24 } from './positioning-bottom_24.svg';
export { default as positioningCenter_24 } from './positioning-center_24.svg';
export { default as positioningLeft_24 } from './positioning-left_24.svg';
export { default as positioningRight_24 } from './positioning-right_24.svg';
export { default as positioningTopLeft_24 } from './positioning-top-left_24.svg';
export { default as positioningTopRight_24 } from './positioning-top-right_24.svg';
export { default as post_16 } from './post_16.svg';
export { default as questionMark_16 } from './question-mark_16.svg';
export { default as redirect_16 } from './redirect_16.svg';
export { default as replied_16 } from './replied_16.svg';
export { default as replyNegative_16 } from './reply-negative_16.svg';
export { default as reply_16 } from './reply_16.svg';
export { default as reportActive_16 } from './report-active_16.svg';
export { default as report_16 } from './report_16.svg';
export { default as reviewProduct_16 } from './review-product_16.svg';
export { default as reviewQuote_16 } from './review-quote_16.svg';
export { default as search_16 } from './search_16.svg';
export { default as search_24 } from './search_24.svg';
export { default as share_16 } from './share_16.svg';
export { default as simpleArrowDown_16 } from './simple-arrow-down_16.svg';
export { default as simpleArrowUp_16 } from './simple-arrow-up_16.svg';
export { default as simpleArrow_16 } from './simple-arrow_16.svg';
export { default as sortableArrowDown_16 } from './sortable-arrow-down_16.svg';
export { default as sortableArrowUp_16 } from './sortable-arrow-up_16.svg';
export { default as sortableArrow_16 } from './sortable-arrow_16.svg';
export { default as star_16 } from './star_16.svg';
export { default as thrash_16 } from './thrash_16.svg';
export { default as trash_16 } from './trash_16.svg';
export { default as twitter_16 } from './twitter_16.svg';
export { default as unclaimed_16 } from './unclaimed_16.svg';
export { default as useful_16 } from './useful_16.svg';
export { default as verifiedOrder_16 } from './verified-order_16.svg';
export { default as verified_16 } from './verified_16.svg';
export { default as warning_16 } from './warning_16.svg';
export { default as youtube_16 } from './youtube_16.svg';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/icons/lib/index.js
// module id = 16
// module chunks = 0